import { Delimiters } from ".";
import { NumberIndexedDictionary } from "../../../globalTypes";

export enum TypeEnum {
  label = "label",
  value = "value",
  labelCustom = "label-custom",
  empty = "empty",
  delimiter = "delimiter",
}

export type CellDataDTO = {
  type: TypeEnum;
  columnValueIndex: number;
  delimiterId: string;
  x: number;
  y: number;
  rowspan: number;
  colspan: number;
};

export type MobileRowLayoutDTO = {
  columns: number;
  rows: number;
  layout: NumberIndexedDictionary<CellDataDTO>;
  delimiters: Delimiters;
};
